import React, { ChangeEvent } from "react"
import { AppFunctionComponent } from "../../../types"
import { SubmenuItem } from "../../types/menu.interface"
import FooterMenu from "../../components/footer/footer.component"
import useTranslationHook from "../../../hooks/use-translation.hook"
import { Path } from "../../constants/routes"

type Props = {
  navigationItems: SubmenuItem[]
}

const Footer: AppFunctionComponent<Props> = ({ navigationItems }) => {
  const { changeLanguageManually, language } = useTranslationHook()

  const languageChange = (e: ChangeEvent<HTMLSelectElement>) => {
    changeLanguageManually(e.target.value)
  }

  return (
    <FooterMenu
      languageChange={languageChange}
      logoPath={Path.Home}
      navigationItems={navigationItems}
      languageValue={language}
    />
  )
}

export default Footer
